/*
 * @Author: cryi.liu
 * @Date: 2020-04-30 09:35:30
 * @LastEditTime: 2020-06-21 17:23:47
 * @Description: 应用主入口
 */
import Vue from 'vue';
import Saec from './Saec.vue';
import router from './router';
import store from './store';
import http from './plugins/http';
import iview from './plugins/iview';
import globalCom from './plugins/globalCom';
import base64 from './plugins/base64';
import pdfobject from './plugins/pdfobject';
import devUtil from './utils/dev';

Vue.config.productionTip = false;

Vue.use(http);
Vue.use(iview);
Vue.use(globalCom);
Vue.use(base64);
Vue.use(pdfobject);

const render = () => {
  new Vue({
    router,
    store,
    render: (h) => h(Saec),
  }).$mount('#saec');
};

if (process.env.NODE_ENV === 'development') {
  console.log('当前环境: development');
  devUtil.login('201186', 'sfmd1234')
    .then((result) => {
      if (result.success) {
        console.log('登录成功');
        store.dispatch('authStore/invokeSetToken', { token: result.loginToken });
      } else {
        console.log('登录失败');
      }

      render();
    });
} else {
  const pssToken = localStorage.getItem('pssToken');
  const examToken = localStorage.getItem('examToken');

  if (pssToken) {
    store.dispatch('authStore/invokeSetToken', { token: pssToken });
  }

  if (examToken) {
    store.dispatch('authStore/invokeSetExamToken', { examToken });
  }

  render();
}
